import React from 'react';
import { Box, Text } from '@chakra-ui/react';

interface ResidentHeadlineProps {
  title: string;
  description?: string;
}

const ResidentHeadline: React.FC<ResidentHeadlineProps> = ({ title, description }) => {
  return (
    <Box textAlign="left" mb={6}>
      <Text
        fontSize="25px"
        fontWeight={500}
        color="#000"
      >
        {title}
      </Text>
      {description && (
        <Text
          fontSize="18px"
          fontWeight={400}
          color="#000"
        >
          {description}
        </Text>
      )}
    </Box>
  );
};

export default ResidentHeadline;
